/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import {
  Chip,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Menu,
  MenuItem,
} from '@material-ui/core'
import React, { useState } from 'react'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  root: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  chip: {
    height: 38,
    backgroundColor: '#ECF2F5',
    textTransform: 'capitalize',
    [theme.breakpoints.only('xs')]: {
      display: 'none',
    },
  },
  notification: {
    width: 340,
    height: 340,
    borderRadius: 5,
    marginTop: 60,
    marginLeft: -150,
    border: 'solid 0.5px #cccccc',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: 'RGBA(85,111,181,0.6)',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
    },
  },
  userMenu: {
    width: 300,
    height: 'auto',
    marginTop: 60,
    marginLeft: 'auto',
  },
}))

const MenuList = (props) => {
  const {
    anchorEl, onClose, menuItem,
  } = props
  const classes = useStyles()
  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={onClose}
      elevation={0}
      classes={{
        paper: clsx(classes.notification, classes.userMenu),
      }}
    >
      {
        menuItem.map((item) => (
          <MenuItem
            key={item.id}
            onClick={() => {
              onClose()
              item.onClick()
            }}
          >
            <ListItemIcon>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.name} style={{ marginLeft: -16 }} />
          </MenuItem>
        ))
      }
    </Menu>
  )
}

const ChipMenu = (props) => {
  const classes = useStyles()
  const {
    label, menuItem, avatar,
  } = props
  const [anchorEl, setAnchorEl] = useState(null)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    setMenuOpen(!menuOpen)
  }

  const onClose = () => {
    setMenuOpen(!menuOpen)
    setAnchorEl(null)
  }

  return (
    <div className={classes.root}>
      <Chip
        avatar={avatar}
        label={label}
        className={classes.chip}
        onClick={handleClick}
      />
      <MenuList
        avatar={avatar}
        anchorEl={anchorEl}
        onClose={onClose}
        menuItem={menuItem}
      />
    </div>
  )
}

export default ChipMenu
